import React, { Fragment, Component } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { Link } from 'react-router-dom';
import { Nav, Navbar, NavItem, Image, Col, Button } from 'react-bootstrap';
import $ from 'jquery';
import './EstimatorNavBar.css';
import logo from '../img/dm_logo_white_bg.png';
import { Auth } from 'aws-amplify';
import ProfileModal from './ProfileModal';

export default class EstimatorNavBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      showProfileModal: false
    };
  }

  async componentDidMount() {
    window.scrollTo(0, 0);
    $('.App').css('background-color', 'rgb(255, 255, 255)');
    $('.App').css('background-color', 'rgb(255, 255, 255, 0.9)');
    if (this.props.isAuthenticated) {
      this.getUsername();
    }
  }

  getUsername = async event => {
    try {
      await Auth.currentAuthenticatedUser().then(data =>
        this.setState({ username: data.attributes.email })
      );
    } catch (e) {
      alert(e);
    }
  };

  capitalise = function(arg) {
    return arg.charAt(0).toUpperCase() + arg.slice(1);
  };

  render() {
    const modalClose = () => this.setState({ showProfileModal: false });
    const modalShow = () => this.setState({ showProfileModal: true });
    return (
      <div>
        <Navbar fluid collapseOnSelect>
          <Navbar.Header>
            <Navbar.Brand>
              <a
                className="logo-container"
                href="http://www.digimasters.co.uk"
                target="_blank"
                rel="noopener noreferrer">
                <Image src={logo} className="navbar-logo" />
              </a>
            </Navbar.Brand>
            <Navbar.Brand>
              <Link to="/">Home</Link>
            </Navbar.Brand>
            <Navbar.Brand>
              <Link to="/beta">Your Estimates</Link>
            </Navbar.Brand>
            <Navbar.Brand>
              <Link to="/blog">Blog</Link>
            </Navbar.Brand>
            <Navbar.Toggle />
          </Navbar.Header>
          <Navbar.Collapse>
            <Nav pullRight>
              {this.props.isAuthenticated ? (
                <Fragment>
                  <NavItem onClick={modalShow}>Profile</NavItem>
                  <NavItem onClick={this.props.appLogout}>Logout</NavItem>
                </Fragment>
              ) : (
                <Fragment>
                  <LinkContainer to="/register">
                    <NavItem>Register</NavItem>
                  </LinkContainer>
                  <LinkContainer to="/login">
                    <NavItem>Login</NavItem>
                  </LinkContainer>
                </Fragment>
              )}
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        {this.props.isAuthenticated ? (
          <ProfileModal
            show={this.state.showProfileModal}
            onHide={modalClose}
          />
        ) : null}
        {this.props.isAuthenticated ? (
          <div>
            <Col xs={6} md={3}>
              {!this.props.hideUpgradeLink &&
              this.props.accountType === 'free' ? (
                <Link to="/upgrade">
                  <Button bsStyle="success">Upgrade Account</Button>
                </Link>
              ) : null}
            </Col>
            <Col xs={0} md={6} />
            <Col xs={6} md={3}>
              <p className="account-info">{this.state.username}</p>
              <p className="account-info">
                Account Type:{' '}
                <span className="account-type">
                  {this.capitalise(this.props.accountType)}
                </span>
              </p>
            </Col>
          </div>
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EstimatorNavBar.js